<div class="dialog">
  <div class="dialog-header">
    <div>
      <span class="dialog-eyebrow">
        Tarča {{ target?.TargetOrder || '-' }} · zapis #{{ target?.targetID }}
      </span>
      <h3>Uredi podatke rezultata</h3>
      <p class="dialog-description">Določite strelca, tekmovanje, kategorijo in po želji ekipo.</p>
    </div>
    <button type="button" class="close-button" title="Zapri" aria-label="Zapri okno" (click)="onCancel()">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <form class="dialog-form" (ngSubmit)="onSave()">
    <div class="form-section">
      <div class="section-heading">
        <span class="section-icon"><i class="fas fa-user-tag"></i></span>
        <div><strong>Podatki o nastopu</strong><small>Izberite podatke, ki pripadajo tej tarči.</small></div>
      </div>
      <label class="field-label club-field">
        <span>Strelski klub</span>
        <div class="field-control relative">
          <i class="fas fa-building field-leading-icon"></i>
          <input class="form-control has-leading-icon" type="text" [(ngModel)]="clubSearch" name="clubSearch" (input)="onClubSearchChange()" (focus)="showClubDropdown = true" (blur)="onClubBlur()" placeholder="Izberite klub" autocomplete="off" role="combobox" [attr.aria-expanded]="showClubDropdown" aria-controls="clubSuggestions" />
          <i *ngIf="selectedClub" class="fas fa-check field-status-icon" aria-hidden="true"></i>
          <div *ngIf="showClubDropdown" id="clubSuggestions" class="suggestions absolute z-50 w-full bg-white overflow-y-auto" role="listbox">
            <button type="button" *ngFor="let club of getFilteredClubs()" class="suggestion-item" (mousedown)="selectClub(club)" role="option">
              <span>{{ club.name }}</span><small>{{ club.code || ('ID ' + club.club_id) }}</small>
            </button>
            <div *ngIf="getFilteredClubs().length === 0" class="suggestion-empty">Ni najdenih klubov.</div>
          </div>
        </div>
      </label>
      <label class="field-label">
        <span>Strelec</span>
        <div class="field-control relative">
          <i class="fas fa-search field-leading-icon"></i>
          <input class="form-control has-leading-icon" type="text" [(ngModel)]="memberSearch" name="memberSearch" (input)="onMemberSearchChange()" (focus)="showMemberDropdown = true" (blur)="onMemberBlur()" placeholder="Ime ali ID strelca" autocomplete="off" role="combobox" [attr.aria-expanded]="showMemberDropdown" aria-controls="memberSuggestions" />
          <i *ngIf="selectedMember" class="fas fa-check field-status-icon" aria-hidden="true"></i>
          <div *ngIf="showMemberDropdown" id="memberSuggestions" class="suggestions absolute z-50 w-full bg-white overflow-y-auto" role="listbox">
            <button type="button" *ngFor="let member of getFilteredMembers()" class="suggestion-item" (mousedown)="selectMember(member)" role="option">
              <span>{{ member.full_name }}</span><small>ID {{ member.member_id }}</small>
            </button>
            <div *ngIf="getFilteredMembers().length === 0" class="suggestion-empty">Ni najdenih strelcev.</div>
          </div>
        </div>
      </label>
      <label class="field-label">
        <span>Tekmovanje</span>
        <div class="field-control relative">
          <i class="fas fa-search field-leading-icon"></i>
          <input class="form-control has-leading-icon" type="text" [(ngModel)]="competitionSearch" name="competitionSearch" (input)="onCompetitionSearchChange()" (focus)="showCompetitionDropdown = true" (blur)="onCompetitionBlur()" placeholder="Ime ali ID tekmovanja" autocomplete="off" role="combobox" [attr.aria-expanded]="showCompetitionDropdown" aria-controls="competitionSuggestions" />
          <i *ngIf="selectedCompetition" class="fas fa-check field-status-icon" aria-hidden="true"></i>
          <div *ngIf="showCompetitionDropdown" id="competitionSuggestions" class="suggestions absolute z-50 w-full bg-white overflow-y-auto" role="listbox">
            <button type="button" *ngFor="let competition of getFilteredCompetitions()" class="suggestion-item" (mousedown)="selectCompetition(competition)" role="option">
              <span>{{ competition.competition_name }}</span><small>ID {{ competition.competitionId }}</small>
            </button>
            <div *ngIf="getFilteredCompetitions().length === 0" class="suggestion-empty">Ni najdenih tekmovanj.</div>
          </div>
        </div>
      </label>
      <label class="field-label">
        <span>Kategorija</span>
        <div class="field-control relative">
          <i class="fas fa-search field-leading-icon"></i>
          <input class="form-control has-leading-icon" type="text" [(ngModel)]="categorySearch" name="categorySearch" (input)="onCategorySearchChange()" (focus)="showCategoryDropdown = true" (blur)="onCategoryBlur()" placeholder="Ime ali ID kategorije" autocomplete="off" role="combobox" [attr.aria-expanded]="showCategoryDropdown" aria-controls="categorySuggestions" />
          <button *ngIf="categorySearch" type="button" class="field-clear" aria-label="Počisti kategorijo" (mousedown)="$event.preventDefault()" (click)="categorySearch = ''; target.category_id = null; target.teams_number = null; selectedCategory = null; showCategoryDropdown = true"><i class="fas fa-times"></i></button>
          <div *ngIf="showCategoryDropdown" id="categorySuggestions" class="suggestions absolute z-50 w-full bg-white overflow-y-auto" role="listbox">
            <button type="button" *ngFor="let category of getFilteredCategories()" class="suggestion-item" (mousedown)="selectCategory(category)" role="option">
              <span>{{ category.category_name }}</span><small>ID {{ category.category_id }}</small>
            </button>
            <div *ngIf="getFilteredCategories().length === 0" class="suggestion-empty">Ni najdenih kategorij.</div>
          </div>
        </div>
      </label>
    </div>

    <div class="form-section team-section">
      <div class="section-heading">
        <span class="section-icon"><i class="fas fa-users"></i></span>
        <div><strong>Ekipa</strong><small>Dodajte samo pri ekipnem nastopu.</small></div>
        <span class="optional-badge">Neobvezno</span>
      </div>
      <label class="field-label">
        <span>Številka ekipe</span>
        <div class="team-number-control">
          <select class="form-control" [(ngModel)]="selectedTeamNumber" name="teams_number" [disabled]="!selectedClub" aria-label="Izberite številko ekipe">
            <option [ngValue]="null">Brez ekipnega nastopa</option>
            <option *ngFor="let teamNumber of teamNumbers" [ngValue]="teamNumber">{{ selectedClub?.name }} {{ teamNumber }}</option>
          </select>
        </div>
        <span class="field-hint"><i class="fas fa-info-circle"></i> Najprej izberite klub, nato po potrebi številko ekipe 1, 2 ali 3.</span>
        <span *ngIf="teamNumberError" class="field-error">{{ teamNumberError }}</span>
      </label>
    </div>

    <div class="dialog-actions">
      <button type="button" class="clear-button" (click)="clearData()"><i class="fas fa-trash-alt"></i> Odstrani vse povezave</button>
      <div class="action-group">
        <button type="button" class="secondary-button" (click)="onCancel()">Prekliči</button>
        <button type="submit" class="primary-button"><i class="fas fa-save"></i> Shrani spremembe</button>
      </div>
    </div>
  </form>
</div>